module.exports = __webpack_public_path__ + "static/media/Obrazec na pulnomoshtno_22.05.2018.85fe67b3.doc";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Obrazec na pulnomoshtno_22.05.2018.doc
// module id = 140
// module chunks = 0